import { call, put, select } from 'redux-saga/effects';
import { activeUserCountUpdated } from 'features/toolbar/toolbarSlice';
import { selectAvailableUserIds } from 'features/users/usersSlice';
import { UserId } from 'features/users/types';
import { countVisibleUsersSaga } from 'features/users/sagas/countVisibleUsersSaga';

export function* onSipBridgeDisconnectedForCountSaga() {
  const availableUserIds: UserId[] = yield select(selectAvailableUserIds);
  const visibleUsersCount: number = yield call(countVisibleUsersSaga, availableUserIds);

  yield put(activeUserCountUpdated(visibleUsersCount));
}
